import { required } from "@vee-validate/rules";

/**
 * SMSを送受信可能な電話番号かどうかを判定するルール
 * スペースや空白文字も含む
 */
export const phoneNumberWithSpaceRule = {
  validate: (value: string) => {
    // 070, 080, 090で始まる11桁の電話番号
    return /^(070|080|090)\s?\d{4}\s?\d{4}$/.test(value);
  },
  message: "070, 080, 090のいずれかから始まる携帯電話番号を入力してください"
};

/**
 * SMSを送受信可能な電話番号かどうかを判定するルール
 */
export const phoneNumberToReceiveSMSRule = {
  // eslint-disable-next-line
  validate: (value: any) => {
    return /^(070|080|090)/.test(value);
  },
  message: "070, 080, 090のいずれかから始まる携帯電話番号を入力してください"
};

/**
 * 必須チェックを行うが、値が false の場合はチェックをスルーするルール
 *
 * @param value チェックする値
 * @returns 値として問題なければ true
 */
export const requiredAllowFalse = (value: unknown) => {
  if (value !== false) {
    return required(value);
  }
  return true;
};
